import React, { useEffect, useState } from 'react';
import { getArticlesForSelect, getArticle } from '../../../lib/articleRequests';
import DropDown from '../Inputs/DropDown';

type ArticleFilter = {
  id: number,
  title: string
}

type ArticleOption = {
  value: number,
  label: string
}

const ArticleFilterDropDown = (props: {
  className?: string,
  onArticleChange?: Function,
  articleId?: string,
  clearable: boolean,
}) => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [articleFilters, setArticleFilters] = useState([] as ArticleOption[]);
  const [selectedArticle, setSelectedArticle] = useState(undefined);
  const [canLoadMore, setCanLoadMore] = useState(true);
  const [loadedPages, setLoadedPages] = useState({});

  const perPage = 40;
  
  const formatArticleFilters = (apiArticles: ArticleFilter[]) => {
    return apiArticles.map((articleFilter) => {
      return {
        label: articleFilter.title,
        value: articleFilter.id
      }
    });
  }

  const articleInFilters = (articleId: number, filters: Array<ArticleOption>) => {
    const filtered = filters.filter((af) => af.value === articleId);
    return filtered.length > 0;
  }

  const loadNextArticleFilters = () => {
    if(!canLoadMore || loadedPages[page]) return;
    setLoading(true);
    getArticlesForSelect(page, perPage).then((response) => {
      setLoadedPages({
        ...loadedPages,
        [page]: true,
      });

      // if a single article was added from route param, need to only add that single
      // back to options if its page hasn't loaded yet. If the page loads, no longer 
      // need to add single manually to options. Prevents duplicate key/article
      if (articleFilters.length % perPage !== 0) {
        const articlesCopy = articleFilters.slice();
        const articleSingle = articlesCopy.pop();
        const newPageFilters = formatArticleFilters(response.data.articles);
        if(!articleInFilters(articleSingle.value, newPageFilters)) {
          newPageFilters.push(articleSingle);
        }
        setArticleFilters([...articlesCopy, ...newPageFilters]);
      } else {
        setArticleFilters([...articleFilters, ...formatArticleFilters(response.data.articles)]);
      }
      
      setCanLoadMore(response.data.canLoadMore);
      setLoading(false);
    });
  }

  useEffect(() => {
    loadNextArticleFilters();
  }, []);

  useEffect(() => {
    if(!loading) {
      loadNextArticleFilters();
    }
  }, [page, loading]);

  useEffect(() => {
    if(!loading && props.articleId && ((selectedArticle && selectedArticle.value !== props.articleId) || !selectedArticle)) {
      getArticle(props.articleId).then((response) => {
        const singleArticleFilter = {
          label: response.data.title,
          value: response.data.id,
        }  
        
        if(!articleInFilters(response.data.id, articleFilters)) {
          setArticleFilters([...articleFilters, singleArticleFilter]);
        }

        setSelectedArticle(singleArticleFilter);
      });
    }
  }, [props.articleId, loading]);

  const nextPage = () => {
    if(canLoadMore) setPage(page+1);
  }

  return (
    <div className={props.className}>
      <DropDown
        type="line"
        placeholder="Select an article..."
        value={selectedArticle ? selectedArticle.label : undefined}
        options={articleFilters}
        onOptionSelect={(e) => {
          if (!!props.onArticleChange) props.onArticleChange(e);
          setSelectedArticle(e);
        }}
        bottomReached={nextPage}
        clearable={props.clearable}
        className={`truncate`}
      />
    </div>
  )

}

export default ArticleFilterDropDown;